/* ============================================================================
   Kolrin Funnel — exit-intent, social proof, shipping bar, bundle widget
   Single bundle, dependency-free. Loaded with `defer` from layout/theme.liquid.
   ============================================================================ */
(function () {
  'use strict';

  var doc = document;
  var win = window;

  function once(fn) {
    var called = false;
    return function () {
      if (called) return;
      called = true;
      try { fn.apply(null, arguments); } catch (e) { /* swallow */ }
    };
  }

  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function isMobile() {
    return win.matchMedia && win.matchMedia('(max-width: 767px)').matches;
  }

  function safeStorage() {
    try {
      var test = '__k';
      win.sessionStorage.setItem(test, '1');
      win.sessionStorage.removeItem(test);
      return win.sessionStorage;
    } catch (e) {
      return { getItem: function () { return null; }, setItem: function () {}, removeItem: function () {} };
    }
  }
  var STORAGE = safeStorage();

  /* ------------------------------------------------------------
     1. EXIT-INTENT POPUP
     ------------------------------------------------------------ */
  function initExitIntent() {
    var modal = doc.getElementById('KolrinExitIntent');
    if (!modal) return;
    var key = modal.getAttribute('data-cookie-key') || 'kolrin_exit_shown_v1';
    if (STORAGE.getItem(key)) return;

    var revealed = false;

    function show() {
      if (revealed) return;
      revealed = true;
      STORAGE.setItem(key, '1');
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      doc.body.classList.add('kolrin-no-scroll');
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    }

    function hide() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      doc.body.classList.remove('kolrin-no-scroll');
      setTimeout(function () { modal.hidden = true; }, 280);
    }

    modal.querySelectorAll('[data-kolrin-exit-close]').forEach(function (el) {
      el.addEventListener('click', hide);
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) hide();
    });

    var triggerOnce = once(show);

    if (!isMobile()) {
      doc.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 8 && !revealed) triggerOnce();
      });
    } else {
      var lastY = 0;
      var armedAt = Date.now() + 22000; // armed after 22s
      win.addEventListener('scroll', function () {
        var y = win.scrollY || win.pageYOffset;
        if (Date.now() > armedAt && lastY - y > 80 && y < 200 && !revealed) {
          triggerOnce();
        }
        lastY = y;
      }, { passive: true });
    }

    // Form: faktyczny POST do Shopify /contact (form_type=customer + tag "newsletter, exit-intent")
    // Następnie pokazujemy ekran sukcesu inline (nie czekamy na response — Shopify zawsze 302/200).
    var form = modal.querySelector('[data-kolrin-exit-form]');
    var success = modal.querySelector('[data-kolrin-exit-success]');
    if (form && success) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
          if (typeof form.reportValidity === 'function') form.reportValidity();
          return;
        }
        var fd;
        try { fd = new FormData(form); } catch (err) { fd = null; }
        if (fd && win.fetch) {
          // Background submit; ignorujemy redirect/CORS — Shopify rejestruje wpis przed redirectem
          win.fetch(form.action || '/contact#newsletter', {
            method: 'POST',
            body: fd,
            credentials: 'same-origin',
            redirect: 'manual'
          }).catch(function () { /* swallow — redirect manual może rzucić TypeError */ });
        }
        form.hidden = true;
        success.hidden = false;
      });
    }
    var copyBtn = modal.querySelector('[data-kolrin-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.textContent.trim();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            var hint = modal.querySelector('.kolrin-exit-intent__copy-hint');
            if (hint) hint.textContent = '(kopiert!)';
          }).catch(function () {});
        }
      });
    }
  }

  /* ------------------------------------------------------------
     2. SOCIAL PROOF TOAST
     ------------------------------------------------------------ */
  var SOCIAL_PROOF_EVENTS = [
    { name: 'Anna',      city: 'aus Berlin',       product: 'ZEN Drops',           minutesAgo: 3 },
    { name: 'Markus',    city: 'aus München',      product: 'ZEN Drops',           minutesAgo: 7 },
    { name: 'Lisa',      city: 'aus Hamburg',      product: 'ZEN Calming Treats',  minutesAgo: 12 },
    { name: 'Stefan',    city: 'aus Köln',         product: 'ZEN Drops',           minutesAgo: 18 },
    { name: 'Sabine',    city: 'aus Frankfurt',    product: 'ZEN Bundle',          minutesAgo: 22 },
    { name: 'Tobias',    city: 'aus Stuttgart',    product: 'ZEN Drops',           minutesAgo: 5 },
    { name: 'Marie',     city: 'aus Düsseldorf',   product: 'ZEN Drops',           minutesAgo: 9 },
    { name: 'Julian',    city: 'aus Leipzig',      product: 'ZEN Calming Treats',  minutesAgo: 14 }
  ];

  function initSocialProof() {
    var toast = doc.getElementById('KolrinSocialProof');
    if (!toast) return;
    var key = toast.getAttribute('data-cookie-key') || 'kolrin_proof_dismissed_v1';
    if (STORAGE.getItem(key)) return;

    var minDelay = parseInt(toast.getAttribute('data-min-delay'), 10) || 22000;
    var maxDelay = parseInt(toast.getAttribute('data-max-delay'), 10) || 48000;
    var displayTime = parseInt(toast.getAttribute('data-display-time'), 10) || 6500;
    var nameEl = toast.querySelector('[data-kolrin-proof-name]');
    var cityEl = toast.querySelector('[data-kolrin-proof-city]');
    var productEl = toast.querySelector('[data-kolrin-proof-product]');
    var timeEl = toast.querySelector('[data-kolrin-proof-time]');

    var dismissed = false;
    var prefersReduced = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;

    toast.querySelectorAll('[data-kolrin-proof-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dismissed = true;
        STORAGE.setItem(key, '1');
        hideToast();
      });
    });

    function showToast() {
      if (dismissed) return;
      var ev = SOCIAL_PROOF_EVENTS[Math.floor(Math.random() * SOCIAL_PROOF_EVENTS.length)];
      if (nameEl) nameEl.textContent = ev.name;
      if (cityEl) cityEl.textContent = ev.city;
      if (productEl) productEl.textContent = ev.product;
      if (timeEl) timeEl.textContent = 'vor ' + ev.minutesAgo + ' Minuten';
      toast.hidden = false;
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
      setTimeout(hideToast, displayTime);
    }
    function hideToast() {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, prefersReduced ? 0 : 320);
      if (!dismissed) scheduleNext();
    }
    function scheduleNext() {
      var delay = minDelay + Math.floor(Math.random() * (maxDelay - minDelay));
      setTimeout(showToast, delay);
    }

    // First toast after slightly longer delay
    setTimeout(showToast, minDelay);
  }

  /* ------------------------------------------------------------
     3. FREE SHIPPING PROGRESS BAR
     Listens to Shopify ajax cart updates; falls back to fetching /cart.js
     ------------------------------------------------------------ */
  function formatMoney(cents, currency) {
    try {
      var fmt = new Intl.NumberFormat(doc.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency || (win.Shopify && win.Shopify.currency && win.Shopify.currency.active) || 'EUR',
        minimumFractionDigits: 2
      });
      return fmt.format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' €';
    }
  }

  var SHIP_ICON_TRUCK =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 18H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10v13"/><path d="M14 9h4l3 4v5h-2"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>';
  var SHIP_ICON_CHECK =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function updateShippingBars(cartTotal) {
    var total = typeof cartTotal === 'number' ? cartTotal : 0;
    var bars = doc.querySelectorAll('[data-kolrin-shipping-bar]');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 5000;
      if (threshold <= 0) threshold = 5000;
      var track = bar.querySelector('[data-kolrin-shipping-track]');
      var fill = bar.querySelector('[data-kolrin-shipping-fill]');
      var textWrap = bar.querySelector('[data-kolrin-shipping-text]');
      var iconEl = bar.querySelector('.kolrin-shipping-bar__icon');
      var pct = Math.min(100, Math.max(0, (total / threshold) * 100));
      if (fill) fill.style.width = pct.toFixed(1) + '%';
      if (track) track.style.setProperty('--kolrin-progress', pct.toFixed(1) + '%');
      var achieved = total >= threshold;
      bar.classList.toggle('kolrin-shipping-bar--achieved', achieved);
      if (iconEl) iconEl.innerHTML = achieved ? SHIP_ICON_CHECK : SHIP_ICON_TRUCK;
      if (achieved && textWrap) {
        textWrap.innerHTML = '<strong>Glückwunsch!</strong> Du hast kostenlosen Versand freigeschaltet.';
      } else if (!achieved && textWrap) {
        textWrap.innerHTML =
          'Noch <strong data-kolrin-shipping-remaining>' +
          formatMoney(Math.max(0, threshold - total)) +
          '</strong> bis kostenlosem Versand';
      }
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function initShippingBar() {
    if (!doc.querySelector('[data-kolrin-shipping-bar]')) return;
    fetchCart().then(function (cart) {
      if (cart && typeof cart.total_price === 'number') updateShippingBars(cart.total_price);
    });

    // Hook into common Minimog/Shopify cart update events
    ['cart:refresh', 'cart:updated', 'minimog:cart-updated', 'cart:render'].forEach(function (evt) {
      doc.addEventListener(evt, function () {
        fetchCart().then(function (cart) {
          if (cart && typeof cart.total_price === 'number') updateShippingBars(cart.total_price);
        });
      });
    });

    // Patch fetch to detect /cart/* ajax updates (best-effort fallback)
    var originalFetch = win.fetch;
    if (typeof originalFetch === 'function') {
      win.fetch = function () {
        var args = arguments;
        var url = args[0] && args[0].url ? args[0].url : args[0];
        var promise = originalFetch.apply(this, args);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          promise.then(function () {
            setTimeout(function () {
              fetchCart().then(function (cart) {
                if (cart && typeof cart.total_price === 'number') updateShippingBars(cart.total_price);
              });
            }, 60);
          }).catch(function () {});
        }
        return promise;
      };
    }
  }

  /* ------------------------------------------------------------
     4. BUNDLE SAVINGS WIDGET
     Tier selection updates main-product quantity input + dynamically computes
     savings copy. Works on PDP only.
     ------------------------------------------------------------ */
  function initBundleWidget() {
    var widget = doc.querySelector('[data-kolrin-bundle]');
    if (!widget) return;
    var tiers = widget.querySelectorAll('[data-kolrin-bundle-tier]');
    if (!tiers.length) return;

    // Persist THIS product's tier codes (handle → {duo, trio}) so the cart can
    // later re-derive ALL earned codes across every bundle in it. Without this,
    // each /discount call would overwrite the previous and only one code would
    // survive to checkout. NOTE: the codes must be set "combinable with other
    // product discounts" in Shopify admin for multiple to stick at checkout.
    var STORE_KEY = 'kolrinBundleCodes';
    var handle = widget.getAttribute('data-product-handle') || '';
    function readStore() {
      try { return JSON.parse(win.localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
    }
    function writeStore(m) {
      try { win.localStorage.setItem(STORE_KEY, JSON.stringify(m)); } catch (e) {}
    }
    var duoCode = '', trioCode = '';
    tiers.forEach(function (t) {
      var q = parseInt(t.getAttribute('data-qty'), 10) || 0;
      var c = t.getAttribute('data-discount-code') || '';
      if (q === 2) duoCode = c;
      if (q === 3) trioCode = c;
    });
    // (a) localStorage fallback: handle → { duo, trio }
    if (handle && (duoCode || trioCode)) {
      var _m = readStore();
      _m[handle] = { duo: duoCode, trio: trioCode };
      writeStore(_m);
    }
    // (b) Primary source: carry the codes ON the cart line as hidden line-item
    // properties (underscore = hidden from cart/checkout display). This makes the
    // cart self-describing — no dependency on which product pages were visited.
    function kbProductForm() {
      var q = doc.querySelector('input[name="quantity"], input.m-product-form__quantity-input');
      return (q && q.closest('form')) || doc.querySelector('form[action*="/cart/add"]');
    }
    function kbSetProp(form, key, val) {
      if (!form) return;
      var el = form.querySelector('input[data-kbp="' + key + '"]');
      if (!el) {
        el = doc.createElement('input');
        el.type = 'hidden';
        el.setAttribute('data-kbp', key);
        el.name = 'properties[' + key + ']';
        form.appendChild(el);
      }
      el.value = val || '';
    }
    function kbInjectProps() {
      var form = kbProductForm();
      kbSetProp(form, '_kbduo', duoCode);
      kbSetProp(form, '_kbtrio', trioCode);
    }
    kbInjectProps();

    // Prices come straight from Liquid (real product price). We only keep the
    // big price block in sync with the selected tier and apply the matching
    // discount code automatically on add-to-cart.
    var priceNow = doc.querySelector('.kolrin-price__now');
    var priceWas = doc.querySelector('.kolrin-price__was');
    var priceUnit = doc.querySelector('.kolrin-price__unit');

    function syncPriceBlock(tier) {
      var total = tier.getAttribute('data-total') || '';
      var compare = tier.getAttribute('data-compare') || '';
      var unit = tier.getAttribute('data-unit') || '';
      if (priceNow && total) priceNow.textContent = total;
      if (priceWas) {
        if (compare) { priceWas.textContent = compare; priceWas.style.display = ''; }
        else { priceWas.textContent = ''; priceWas.style.display = 'none'; }
      }
      if (priceUnit && unit) priceUnit.textContent = unit;
    }

    function selectTier(tier) {
      tiers.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-checked', 'false');
      });
      tier.classList.add('is-active');
      tier.setAttribute('aria-checked', 'true');

      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var input = doc.querySelector('input[name="quantity"], input.m-product-form__quantity-input');
      if (input) {
        input.value = qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      widget.setAttribute('data-active-code', tier.getAttribute('data-discount-code') || '');
      kbInjectProps();
      syncPriceBlock(tier);
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () { selectTier(tier); });
    });

    // Auto-activate the highlighted (or middle) tier
    var initial = widget.querySelector('[data-kolrin-bundle-tier].is-default')
      || tiers[1] || tiers[0];
    if (initial) selectTier(initial);

    // ---- Auto-apply the bundle discount code AND show it in the cart ----
    var root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    // Re-render Minimog's cart drawer from a fresh server render (which includes
    // cart_level_discount_applications + per-line item.discounts). Does NOT emit
    // cartUpdate, so this can't loop.
    function refreshCartDrawer() {
      var drawer = doc.querySelector('m-cart-drawer');
      if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
        try { drawer.onCartDrawerUpdate(); } catch (e) {}
      }
      // Cart page (not drawer): reload so the discount shows there too.
      if (!drawer && /\/cart(\/|$|\?)/.test(win.location.pathname)) {
        win.location.reload();
      }
    }

    // Re-derive EVERY earned bundle code from the LIVE cart (per line item:
    // qty >= 3 → TRIO code, qty 2 → DUO code) and apply them SEQUENTIALLY, one
    // /discount request after another. Comma-joined codes are treated by this
    // store as one invalid code (→ nothing at checkout), so we never do that.
    // Codes are applied least-valuable first, so if the store only keeps one, the
    // biggest discount is the last applied (and the one that survives). If the
    // store accumulates combinable codes, all of them stick.
    function reconcileDiscounts() {
      var map = readStore();
      return fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var earned = [];
          (cart.items || []).forEach(function (it) {
            var props = it.properties || {};
            var entry = map[it.handle] || {};
            var duo = props._kbduo || entry.duo || '';
            var trio = props._kbtrio || entry.trio || '';
            var q = it.quantity || 1;
            var lp = it.final_line_price || it.line_price || 0;
            var code = '', val = 0;
            if (q >= 3 && (trio || duo)) { code = trio || duo; val = lp * (trio ? 0.15 : 0.10); }
            else if (q === 2 && duo) { code = duo; val = lp * 0.10; }
            if (code && !earned.some(function (e) { return e.code === code; })) {
              earned.push({ code: code, val: val });
            }
          });
          if (!earned.length) return;
          earned.sort(function (a, b) { return a.val - b.val; }); // biggest applied last
          try { console.log('[kolrin-bundle] applying codes in order:', earned.map(function (e) { return e.code; })); } catch (e) {}
          var chain = Promise.resolve();
          earned.forEach(function (e) {
            chain = chain.then(function () {
              return fetch(root + 'discount/' + encodeURIComponent(e.code) + '?redirect=/cart.js', {
                method: 'GET', credentials: 'same-origin'
              });
            });
          });
          return chain.then(function () {
            refreshCartDrawer();
            ['cart:refresh', 'cart:updated', 'minimog:cart-updated'].forEach(function (evt) {
              try { doc.dispatchEvent(new CustomEvent(evt)); } catch (e) {}
            });
          });
        })
        .catch(function () {});
    }

    // Apply on initial load (covers bundles already in the cart from other
    // product pages) and again whenever the cart changes (Minimog emits its
    // cartUpdate once /cart/add or a qty change resolves).
    reconcileDiscounts();
    try {
      if (win.MinimogEvents && win.MinimogTheme && win.MinimogTheme.pubSubEvents && win.MinimogTheme.pubSubEvents.cartUpdate) {
        win.MinimogEvents.subscribe(win.MinimogTheme.pubSubEvents.cartUpdate, function () {
          setTimeout(reconcileDiscounts, 150);
        });
      }
    } catch (e) {}
  }

  /* ------------------------------------------------------------
     7. CART DRAWER UPSELL v2 — checkbox add/remove, horizontal scroll
     ------------------------------------------------------------ */
  function kolrinNotifyCartRefresh() {
    if (typeof window.refreshCart === 'function') window.refreshCart();
    if (window.MinimogTheme && typeof window.MinimogTheme.refreshCart === 'function') {
      window.MinimogTheme.refreshCart();
    }
    doc.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /**
   * Odświeża koszyk BEZ podmiany innerHTML na hoście m-cart-drawer — pełna podmiana
   * psuje referencje MCartDrawer (cartDrawerInner/overlay) i zamyka / blokuje drawer.
   */
  function kolrinReloadDrawerSafe() {
    var drawer = doc.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate(true);
    }
    fetch(window.location.pathname + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var tmp = doc.createElement('div');
          tmp.innerHTML = html;
          var freshUpsell = tmp.querySelector('.m-cart-drawer__upsell');
          var liveUpsell = doc.querySelector('m-cart-drawer .m-cart-drawer__upsell');
          if (freshUpsell && liveUpsell) {
            liveUpsell.innerHTML = freshUpsell.innerHTML;
          }
        } catch (_) {}
      })
      .catch(function () {});
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents && window.MinimogTheme.pubSubEvents.cartUpdate) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'kolrin-drawer-upsell' });
    }
  }

  function initCartDrawerUpsell() {
    doc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-scroll]');
      if (!btn) return;
      var root = btn.closest('[data-kolrin-drawer-upsell]');
      if (!root) return;
      var scroller = root.querySelector('[data-upsell-scroller]');
      if (!scroller) return;
      var dir = btn.getAttribute('data-upsell-scroll');
      var delta = Math.min(scroller.clientWidth * 0.85, 280);
      scroller.scrollBy({ left: dir === 'next' ? delta : -delta, behavior: 'smooth' });
    });

    doc.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-kolrin-upsell-cb]');
      if (!cb || cb.disabled) return;
      var variantId = cb.getAttribute('data-variant-id');
      if (!variantId) return;

      if (cb.checked) {
        cb.disabled = true;
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (body) {
              if (!res.ok) throw body;
              return body;
            });
          })
          .then(function () {
            kolrinNotifyCartRefresh();
            doc.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
            kolrinReloadDrawerSafe();
          })
          .catch(function () {
            cb.checked = false;
            cb.disabled = false;
          });
      } else {
        cb.disabled = true;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var key = null;
            if (cart && cart.items) {
              for (var i = 0; i < cart.items.length; i++) {
                if (String(cart.items[i].variant_id) === String(variantId)) {
                  key = cart.items[i].key;
                  break;
                }
              }
            }
            if (!key) {
              cb.disabled = false;
              return;
            }
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 }),
            });
          })
          .then(function (res) {
            if (!res) return;
            if (!res.ok) throw new Error('change failed');
            kolrinNotifyCartRefresh();
            kolrinReloadDrawerSafe();
          })
          .catch(function () {
            cb.checked = true;
            cb.disabled = false;
          });
      }
    });
  }

  /* ------------------------------------------------------------
     INIT
     ------------------------------------------------------------ */
  ready(function () {
    initExitIntent();
    initSocialProof();
    initShippingBar();
    initBundleWidget();
    initCartDrawerUpsell();
  });
})();
